<script>
	const zoomFactor = 3;

	export let items = [];
	export let galleryIndex = 0;
	export let normalizedGalleryIndex = 0;
	export let cursor = {x: 0, y: 0, w: 10, offsetX: 0, offsetY: 0, canvasW: 0, canvasH: 0, src: null, canvasEl: null};
	export let zoomActive = false;
	export let previewElMeasures = {w: 0, h: 0};
	export let zoomOffset = {x: 0, y: 0};

	$: zoomOffset = {x: -cursor.offsetX * previewElMeasures.w, y: -cursor.offsetY * previewElMeasures.h};
	$: normalizedGalleryIndex = galleryIndex % items.length;
	$: cursor.src = (items[normalizedGalleryIndex] || {}).zoomSrc || null;
	$: cursor.canvasEl = (items[normalizedGalleryIndex] || {}).element || null;

	setItem(0);

	function setItem(index) {
		galleryIndex = index;
	}

	function prevItem() {
		zoomActive = false;
		galleryIndex = galleryIndex - 1;
		if(galleryIndex < 0) {
			galleryIndex = galleryIndex + items.length;
		}
	}

	function nextItem() {
		zoomActive = false;
		galleryIndex = galleryIndex + 1;
	}

	function mouseMove(e) {
		if(e.target !== cursor.canvasEl) {
			return;
		}
		zoomActive = true;
		if(cursor.canvasW < cursor.canvasH) {
			cursor.w = cursor.canvasW / zoomFactor;
		} else {
			cursor.w = cursor.canvasH / zoomFactor;
		}
		cursor.x = Math.min(Math.max(e.offsetX, cursor.w / 2), cursor.canvasW - cursor.w / 2);
		cursor.y = Math.min(Math.max(e.offsetY, cursor.w / 2), cursor.canvasH - cursor.w / 2);
		cursor.offsetX = (cursor.x - cursor.w / 2) / cursor.canvasW;
		cursor.offsetY = (cursor.y - cursor.w / 2) / cursor.canvasH;
		previewElMeasures = {w: cursor.canvasW * zoomFactor, h: cursor.canvasH * zoomFactor}
	}

	function mouseOut(e) {
		zoomActive = false;
	}
</script>

<div class="product-gallery">
	<div class="product-gallery--stage">
		<div class="product-gallery--stage--items">
			{#each items as item}
				<div class={`product-gallery--stage--item ${item.idx === normalizedGalleryIndex ? 'is-visible' : 'is-hidden'}`} bind:clientWidth={cursor.canvasW} bind:clientHeight={cursor.canvasH} on:mousemove={mouseMove} on:mouseout={mouseOut} on:blur={mouseOut}>
					{#if item.type === 'youtube-video'}
						{#if item.idx === normalizedGalleryIndex && item.videoActive}
							<div class="item youtube-video active">
								{@html item.code}
							</div>
						{:else}
							<div class="item youtube-video inactive">
								<img srcset={item.normalSrcSet} src={item.normalSrc} alt={`Image ${item.idx + 1}`} bind:this={items[item.idx].element} on:click={() => item.videoActive = true}>
							</div>
						{/if}
					{:else}
						<img class="item" srcset={item.normalSrcSet} src={item.normalSrc} alt={`Image ${item.idx + 1}`} bind:this={items[item.idx].element}>
					{/if}
				</div>
			{/each}
		</div>
		{#if items.length > 1}
			<div class="product-gallery--stage--controls">
				<div class="next" on:click={nextItem}><i class="fa fa-arrow-right"></i></div>
				<div class="prev" on:click={prevItem}><i class="fa fa-arrow-left"></i></div>
			</div>
		{/if}
		{#if cursor.src !== null}
			<div class="product-gallery--zoom--cursor {zoomActive ? 'active' : ''}" style="left: {cursor.x}px; top: {cursor.y}px; margin-top: {-cursor.w / 2}px; margin-left: {-cursor.w / 2}px; width: {cursor.w}px; height: {cursor.w}px;"></div>
			<div class="product-gallery--zoom--preview {zoomActive ? 'active' : ''}" style="left: {cursor.canvasW + 10}px; top: 0; bottom: 0; width: {cursor.canvasH}px; height: {cursor.canvasH}px;">
				<div class="img" style="margin-left: {zoomOffset.x}px; margin-top: {zoomOffset.y}px; width: {cursor.canvasW * 3}px; height: {cursor.canvasH * 3}px; background-image: url({cursor.src}); background-size: contain;"></div>
			</div>
		{/if}
	</div>
	{#if items.length > 1}
		<div class="product-gallery--previews">
			{#each items as item}
				<div class={`product-gallery--previews--item ${item.idx === normalizedGalleryIndex ? 'is-selected' : ''}`} on:click={setItem(item.idx)}>
					<div class="product-gallery--previews--item-inner">
						<img srcset={item.thumbSrcSet} src={item.thumbSrc} alt={`Image ${item.idx + 1}`} />
					</div>
				</div>
			{/each}
		</div>
	{/if}
</div>

<style type="text/scss">
	.product-gallery {
		max-width: 100%;
		padding: .5em;

		img {
			max-width: 100%;
		}
	}

	.product-gallery--stage {
		position: relative;
		padding-bottom: 58%;

		.product-gallery--zoom--cursor {
			pointer-events: none;
			user-select: none;
			position: absolute;
			margin: {
				top: -.5em;
				left: -.5em;
				right: .5em;
				bottom: .5em;
			}
			visibility: hidden;
			
			&.active {
				visibility: visible;
			}
		}

		.product-gallery--zoom--preview {
			pointer-events: none;
			user-select: none;
			position: absolute;
			overflow: hidden;
			background-color: white;

			&.active {
			}

			> .img {
				position: absolute;
				top: 0;
				left: 0;
				background-size: contain;
				background-position: center center;
				background-repeat: no-repeat;
			}
		}

		.product-gallery--stage--items {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}

		.product-gallery--stage--controls {
			> .prev, > .next {
				position: absolute;
				align-self: center;
				justify-self: center;
				align-items: center;
				justify-items: center;
				text-align: center;
				z-index: 10000;
			}
		}

		.product-gallery--stage--item {
			position: absolute !important;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			transition: all .3s ease-in-out;

			> .item {
				object-fit: contain;
				width: 100%;
				height: 100%;
				box-sizing: border-box;

				&.youtube-video.inactive {
					cursor: pointer;
				}

				> img {
					object-fit: contain;
					width: 100%;
					height: 100%;
					box-sizing: border-box;
				}
			}

			> .video-container {
				width: 100%;
				height: 100%;
				box-sizing: border-box;
			}

			&.is-visible {
				opacity: 1;
			}

			&.is-hidden {
				opacity: 0;
				z-index: -1;
				pointer-events: none;
			}
		}
	}

	.product-gallery--previews {
		width: 100%;
		gap: .5em;
		align-items: center;
		display: flex;
		justify-content: center;
		flex-direction: row;
		flex-wrap: wrap;
		margin-top: 1em;

		.product-gallery--previews--item {
			flex: 1 1 48px;
			min-width: 32px;
			max-width: 48px;

			&.is-selected {
			}

			.product-gallery--previews--item-inner {
				padding-bottom: 100%;
				position: relative;

				img {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					object-fit: contain;
					box-sizing: border-box;
				}
			}
		}
	}
</style>